import { Col, Container, Row } from "react-bootstrap"
import cardIcon from "../../assets/Icon.png"
import "./DashboardCards.css"
import { Link } from "react-router-dom"

function DashboardCards({items}) {
  
  return (
    <Link>
    <div className="cards_container">
      <Container fluid>
        <Row>
      {items?.length!==0&&items?.map((item,index)=>{
        return(
          <Col md={items?.length===3?4:items?.length===4?3:3}key={index}className="mb-3">
  <Link to={item?.path}>
  <div key={index}className="card_container">
            <img src={cardIcon}alt=""className="mb-2"/>
            <p className="num mb-2">{item.num}</p>
            <p className="name mb-2">{item.name}</p>
            
            
            </div>
  </Link>
           </Col>
        )
      })}
      </Row>
      </Container>
      
    </div>
    </Link>
  )
}

export default DashboardCards
